import React from 'react';

import Button from '@atlaskit/button/new';

export default function ButtonDefaultExample(): React.JSX.Element {
	return <Button>Default button</Button>;
}
